import type { JiraSoftwareNavData } from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/project-sidebar-navigation/types.tsx';
import type { Settings } from './types.tsx';

export const extractData = (
	navData: JiraSoftwareNavData,
	hasActiveSoftwareAccess: boolean,
): Settings => {
	const { permissionInfo } = navData;
	const { isAdmin, projectPermissionsQueried } = permissionInfo;
	const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
	const isProjectOrSiteAdmin = isAdmin || isProjectAdmin;

	const hasEditWorkflowPermissions =
		permissionInfo.projectPermissionsQueried.EDIT_WORKFLOW === true;
	const hasIssueLayoutPermissions =
		permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;

	return {
		hasApps: isProjectOrSiteAdmin,
		hasAutomation: isProjectOrSiteAdmin,
		hasComponents: isProjectOrSiteAdmin,
		hasDeleteProject: false,
		hasDetails: isProjectOrSiteAdmin,
		hasDevtools: hasActiveSoftwareAccess && isProjectAdmin,
		hasFeatures: isProjectOrSiteAdmin,
		hasFields: isProjectOrSiteAdmin,
		hasIssueCollectors: isProjectOrSiteAdmin,
		hasIssueLayout: isProjectOrSiteAdmin || hasIssueLayoutPermissions,
		/**
		 * If Issue Layout is true but Issues Dropdown is false (in the case of non admin with Edit Issue Layout permission),
		 * the issues expandable section will be replaced by a top-level menu item for edit issue layout only.
		 */
		hasIssuesDropdown: isProjectOrSiteAdmin,
		hasIssueSecurity: isProjectOrSiteAdmin,
		hasIssueTypes: isAdmin,
		hasNotifications: isProjectOrSiteAdmin,
		hasOpsgenie: isAdmin,
		hasPeople: isProjectOrSiteAdmin,
		hasPermissions: isProjectOrSiteAdmin,
		hasPersonaForms: isProjectOrSiteAdmin,
		hasScreens: isProjectOrSiteAdmin,
		hasSummary: isProjectOrSiteAdmin,
		hasToolchains: isProjectOrSiteAdmin,
		hasWorkflows: isProjectOrSiteAdmin || hasEditWorkflowPermissions,
	};
};
